import { Info, PencilSimpleLine, Tag } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import LabelTag from "common/components/LabelTag";
import { Button } from "common/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import type { Label } from "common/types";

import Stepper from "../Stepper";
import FlowReview from "./FlowReview";
import ScheduleReview from "./ScheduleReview";
import StartCampaignButton from "./StartCampaignButton";

import type { CampaignFlow } from "../../../../types";

export default function Review({
  flows,
  autoLabels,
}: {
  flows: CampaignFlow[];
  autoLabels: Label[];
}) {
  return (
    <>
      <article className="grid gap-4 lg:grid-cols-5 lg:items-start">
        <div className="flex flex-col rounded-3xl border border-black-200 p-3 gap-y-3 lg:col-span-3">
          <div className="flex justify-between gap-4 items-center lg:gap-3">
            <div className="flex flex-col gap-y-0.5">
              <h2 className="text-button-md">Campaign Flows</h2>
              <p className="text-xs text-black-500">
                Set up your campaign by selecting an audience, flow and schedule
              </p>
            </div>
            <Button variant="secondary-black" intent="iconOnly" asChild>
              <Link to="../flows">
                <PencilSimpleLine />
              </Link>
            </Button>
          </div>
          {autoLabels.length && (
            <div className="p-3 flex items-center border border-black-200 rounded-3xl">
              <Tag className="m-2.5 size-5 mr-2" weight="fill" />
              <span className="text-sm-bold mr-1">Auto-label</span>
              <Tooltip>
                <TooltipTrigger>
                  <Info weight="fill" size={16} className="text-black-300" />
                </TooltipTrigger>
                <TooltipContent>
                  You can automatically label all targets that accept your
                  connection requests or respond to your campaign
                </TooltipContent>
              </Tooltip>
              <div className="flex gap-1.5 flex-1 justify-end flex-wrap ml-2.5 overflow-hidden">
                {autoLabels.map((label) => (
                  <LabelTag key={label.id} label={label} />
                ))}
              </div>
            </div>
          )}
          {flows.map((flow) => (
            <FlowReview key={flow.id} flow={flow} />
          ))}
        </div>
        <ScheduleReview />
      </article>

      <Stepper
        selectedIndex={4}
        nextButtonComponent={<StartCampaignButton />}
      />
    </>
  );
}
